import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Compass, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/auth';

/**
 * Endereço que não leva a nenhuma página. Antes a rota curinga mandava para o
 * Início sem avisar, e um link errado no menu parecia "a mesma tela de novo".
 * Agora a pessoa vê o que aconteceu e tem para onde ir.
 */
export function PaginaNaoEncontrada() {
  const { pathname } = useLocation();
  const admin = useAuthStore((s) => s.user?.role === 'ADMIN');

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center py-16 text-center">
      <div className="bg-primary/10 mb-5 flex h-14 w-14 items-center justify-center rounded-2xl">
        <Compass className="text-primary h-7 w-7" />
      </div>
      <h1 className="text-2xl font-bold">Esta página não existe</h1>
      <p className="text-muted-foreground mt-2">
        O endereço{' '}
        <code className="bg-secondary/60 text-foreground rounded px-1.5 py-0.5 text-sm">
          {pathname}
        </code>{' '}
        não leva a nenhuma página da plataforma.
      </p>
      {admin && (
        <p className="text-muted-foreground mt-3 text-sm">
          Se você chegou aqui por um item do menu, confira o endereço dele em{' '}
          <Link to="/admin/cms" className="text-primary hover:underline">
            Admin → Personalização → Menu
          </Link>
          .
        </p>
      )}
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Button asChild>
          <Link to="/home">
            <Home className="h-4 w-4" />
            Ir para o início
          </Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/courses">
            <BookOpen className="h-4 w-4" />
            Explorar catálogo
          </Link>
        </Button>
      </div>
    </div>
  );
}
